const locator = window.navigator.geolocation;

const geolocationIsAvailable = () => {
    return 'geolocation' in window.navigator
};

const getPositionData = (resolve, reject) => {
    if (! geolocationIsAvailable()) {
        return reject('No browser support');
    }

    locator.getCurrentPosition(position => {
        resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            altitude: position.coords.altitude,
            altitudeAccuracy: position.coords.altitudeAccuracy,
            accuracy: position.coords.accuracy
        })
    }, () => reject('No position access'));
};

export default {
    getLocation() {
        return new Promise(getPositionData);
    }
};
